import { render, staticRenderFns } from "./_liangdian.vue?vue&type=template&id=11de1c6b&scoped=true"
import script from "./_liangdian.vue?vue&type=script&lang=js"
export * from "./_liangdian.vue?vue&type=script&lang=js"
import style0 from "./_liangdian.vue?vue&type=style&index=0&id=11de1c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11de1c6b",
  null
  
)

export default component.exports